export default "__VITE_ASSET__1417615a__"